import { axiosInstance } from "lib/axios";
import { searchAPI } from "services/apis.service";
import { getFilterDateValueKeys } from "utils/date-filter.util";
import { searchConfig } from "config";

const getSourceConfig = (source) => {
  if (source === "rating") return searchConfig.mediaBias;
  if (source === "partner-publishers") return searchConfig.partnerPublishers;
  if (source === "peer-reviewed") return searchConfig.peerReviewed;
  return searchConfig.categories;
};

const createCategoryAdapter = ({ searchContext, params }) => {
  const {
    currentSearchTerm,
    currentTimeframe,
    startDate,
    endDate,
    sourceCategories,
    currentCategory,
    currentSource,
    currentSubCategory,
    handleSourceCategoryChange,
    sources,
  } = searchContext;

  const { category: categoryParam, source, academiaSearch } = params;

  const categories = handleSourceCategoryChange(source) || sourceCategories;
  const categoryMeta = categoryParam
    ? categories?.find((c) => c?.label === categoryParam)
    : currentSource
      ? sources?.find((s) => s?.key === currentSource)
      : null;

  const pageSize = getSourceConfig(source).count;

  const isSpecialSourceType =
    source === "books" ||
    source === "wiki" ||
    categoryParam === "boclips" ||
    academiaSearch; // Academia uses subcategory

  const enabled = Boolean(
    currentSearchTerm &&
    categoryMeta &&
    (!source || source === currentSource) &&
    !isSpecialSourceType
  );

  const dependencies = [
    currentSearchTerm,
    currentTimeframe,
    startDate,
    endDate,
    currentCategory,
    currentSource,
    categoryParam,
    source,
  ];

  const fetchPage = async (cursor) => {
    if (!enabled) return { items: [], nextCursor: cursor, hasMore: false };
    const media = categoryMeta.label || categoryMeta.categoryName_chr;

    const invalidMediaTypes = ["By Media Bias", "By Categories"];
    if (invalidMediaTypes.includes(media)) {
      return { items: [], nextCursor: cursor, hasMore: false };
    }

    const filteredDateValue = getFilterDateValueKeys(
      currentTimeframe,
      startDate,
      endDate
    );

    const { data } = await axiosInstance.post(searchAPI.search, {
      SearchTerm: currentSearchTerm,
      Media: media,
      timePeriod: filteredDateValue,
      Count: String(pageSize),
      Offset: String(cursor),
    });

    const items = data?.data?.webPages?.value || [];
    const total = data?.data?.webPages?.totalEstimatedMatches || 0;
    const nextCursor = cursor + pageSize;
    const hasMore = nextCursor < total;
    return { items, nextCursor, hasMore };
  };

  return {
    idKey: "url",
    initialCursor: 0,
    fetchPage,
    dependencies,
    enabled,
    isPageMode: false,
  };
};

export default createCategoryAdapter;


